import React from "react";
import Icon from "./Icon";
import Loader from "../Loader";

function ProfileActionButton({ item, ghost }) {
  const klass = 'profile-actions__btn'
    + (item.variant === 'filled' ? ' profile-actions__btn--filled' : '')
    + (ghost ? ' profile-actions__btn--ghost' : '');

  if (item.loading) {
    return (
      <div className={klass} aria-busy="true">
        <Loader />
      </div>
    );
  }

  const inner = (
    <>
      <Icon family={item.iconFamily} name={item.icon} />
      <span>{item.label}</span>
    </>
  );

  if (item.href) {
    return (
      <a href={item.href} className={klass}>
        {inner}
      </a>
    );
  }

  return (
    <button
      type="button"
      className={klass}
      onClick={item.onClick}
      disabled={item.disabled}
    >
      {inner}
    </button>
  );
}

function ProfileActions({ primaryActions = [], secondaryActions = [] }) {
  return (
    <div className="profile-actions" role="group" aria-label="Дії профілю">
      {primaryActions.length > 0 && (
        <div className="profile-actions__group profile-actions__group--primary" aria-label="Основні дії">
          {primaryActions.map((item) => (
            <ProfileActionButton key={item.id} item={item} />
          ))}
        </div>
      )}
      {secondaryActions.length > 0 && (
        <div className="profile-actions__group profile-actions__group--secondary" aria-label="Додаткові дії">
          {secondaryActions.map((item) => (
            <ProfileActionButton key={item.id} item={item} ghost />
          ))}
        </div>
      )}
    </div>
  );
}

export default ProfileActions;
